import Component from './Button.component';
import config from './Button.config';
import model from './Button.model';

export { Component, config, model };

export default Component;
